export type LiveViewerEntry = 'watch_player' | 'interactive_room' | 'shorts_feed';
export type LiveParticipantEntry = 'watch_player' | 'interactive_room' | 'event_stage' | 'shorts_feed';
export type LiveDeliveryKind = 'broadcast' | 'interactive' | 'hybrid';

export interface LiveAudienceContract {
  viewerEntry: LiveViewerEntry;
  participantEntry: LiveParticipantEntry;
  deliveryKind: LiveDeliveryKind;
}

export interface LiveAudienceContractInput {
  source: 'native' | 'shorts' | 'meeting' | 'event' | 'youtube' | 'battle' | 'audio';
  shortsMode?: 'broadcast' | 'interactive';
  broadcastMeeting?: boolean;
  audienceContract?: LiveAudienceContract;
}

export const resolveLiveAudienceContract = (
  input: LiveAudienceContractInput
): LiveAudienceContract => {
  if (input.audienceContract) {
    return input.audienceContract;
  }

  if (input.source === 'native') {
    return {
      viewerEntry: 'watch_player',
      participantEntry: 'watch_player',
      deliveryKind: 'broadcast',
    };
  }

  if (input.source === 'event') {
    return {
      viewerEntry: 'watch_player',
      participantEntry: 'event_stage',
      deliveryKind: 'hybrid',
    };
  }

  if (input.source === 'meeting' && input.broadcastMeeting) {
    return {
      viewerEntry: 'watch_player',
      participantEntry: 'interactive_room',
      deliveryKind: 'hybrid',
    };
  }

  if (input.source === 'shorts' && input.shortsMode === 'broadcast') {
    return {
      viewerEntry: 'shorts_feed',
      participantEntry: 'shorts_feed',
      deliveryKind: 'broadcast',
    };
  }

  return {
    viewerEntry: 'interactive_room',
    participantEntry: 'interactive_room',
    deliveryKind: 'interactive',
  };
};
